import _extends from '@babel/runtime/helpers/esm/extends';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import { isFunction, isEqual } from '@elliemae/ds-utilities/utils';
import DSButton from '@elliemae/ds-basic/Button';
import FilterLabeledPills from './FilterLabeledPills.js';
import FilterDropdownPill from './FilterDropdownPill.js';
import { prepareFilters } from './transformFilters.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@elliemae/ds-basic/Pills';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@elliemae/ds-shared/FocusGroup/useFocusGroupItem';
import '@babel/runtime/helpers/esm/toConsumableArray';
import 'memoize-one';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var blockName = 'filter-bar';
var FilterBarContainer = aggregatedClasses('div')(blockName);
var PillsContainer = aggregatedClasses('div')(blockName, 'pills');
var ButtonsContainer = aggregatedClasses('div')(blockName, 'buttons');
/* eslint-disable prettier/prettier */

var updateFilters = function updateFilters(nextProps, _ref) {
  var prevProps = _ref.prevProps;
  return function (state) {
    return !isEqual(nextProps.filters, prevProps.filters) ? _objectSpread(_objectSpread({}, state), {}, {
      filters: nextProps.filters,
      prevProps: _objectSpread(_objectSpread({}, state.prevProps), {}, {
        filters: nextProps.filters
      })
    }) : state;
  };
};
/* eslint-enable prettier/prettier */


var FilterBarImpl = /*#__PURE__*/function (_PureComponent) {
  _inherits(FilterBarImpl, _PureComponent);

  var _super = _createSuper(FilterBarImpl);

  function FilterBarImpl(props) {
    var _this;

    _classCallCheck(this, FilterBarImpl);

    _this = _super.call(this, props);
    _this.state = {
      filters: props.filters,
      fixedFilters: props.fixedFilters,
      prevProps: {}
    };
    _this.focusGroups = [];
    _this.handleRemoveFilter = _this.handleRemoveFilter.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FilterBarImpl, [{
    key: "setFocusGroup",
    value: function setFocusGroup(index, focusGroup) {
      this.focusGroups[index] = focusGroup;
    }
  }, {
    key: "focusNextGroup",
    value: function focusNextGroup(currIndex) {
      var nextGroup = this.focusGroups[currIndex + 1];

      if (nextGroup) {
        // hack so it doesn't get called 2 times on the next focus group
        setTimeout(function () {
          return nextGroup.actions.focusFirst();
        }, 10);
      }
    }
  }, {
    key: "focusPreviousGroup",
    value: function focusPreviousGroup(currIndex) {
      var prevGroup = this.focusGroups[currIndex - 1];

      if (prevGroup) {
        prevGroup.actions.focusLast();
      }
    }
  }, {
    key: "handleRemoveFilter",
    value: function handleRemoveFilter(_ref2) {
      var pill = _ref2.pill,
          group = _ref2.group;
      var filters = this.state.filters;
      var onRemoveFilter = this.props.onRemoveFilter;
      var pillId = pill === null || pill === void 0 ? void 0 : pill.id;
      var nextFilters = filters.filter(function (filter) {
        return !(filter.group === group && filter.id === pillId);
      });
      this.setState({
        filters: nextFilters
      });
      onRemoveFilter({
        // get remove params from LabeledDropdownSinglePill
        // without breaking backwards compat for group pills
        // eslint-disable-next-line prefer-rest-params
        pill: pill || get(arguments, '0', {}),
        // eslint-disable-next-line prefer-rest-params
        group: group || get(arguments, '1.groupId'),
        nextFilters: nextFilters
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onRemoveAllFilters = _this$props.onRemoveAllFilters,
          renderToolbar = _this$props.renderToolbar,
          containerProps = _this$props.containerProps,
          maxWidth = _this$props.maxWidth,
          minWidth = _this$props.minWidth;
      var filters = this.state.filters;
      var groupedFilters = prepareFilters(filters);
      var renderFilterToolbar = isFunction(renderToolbar) ? renderToolbar({
        onRemoveAllFilters: onRemoveAllFilters
      }) : /*#__PURE__*/React.createElement(DSButton, {
        buttonType: "text",
        labelText: "CLEAR",
        onClick: onRemoveAllFilters
      });
      return /*#__PURE__*/React.createElement(FilterBarContainer, _extends({
        "data-testid": "em-ds-filter-bar"
      }, containerProps), /*#__PURE__*/React.createElement(PillsContainer, null, groupedFilters.map(function (pillGroup, index) {
        var FilterPillComponent = pillGroup.type === 'dropdown' ? FilterDropdownPill : FilterLabeledPills;
        return /*#__PURE__*/React.createElement(FilterPillComponent, {
          key: pillGroup.label,
          groupId: pillGroup.group,
          groupIndex: index,
          label: pillGroup.label,
          maxWidth: maxWidth,
          minWidth: minWidth,
          onFocusGroupSet: function onFocusGroupSet(focusGroup) {
            return _this2.setFocusGroup(index, focusGroup);
          },
          onFocusNextGroup: function onFocusNextGroup() {
            return _this2.focusNextGroup(index);
          },
          onFocusPreviousGroup: function onFocusPreviousGroup() {
            return _this2.focusPreviousGroup(index);
          },
          onRemove: _this2.handleRemoveFilter,
          pills: pillGroup.values
        });
      })), !!filters.length && /*#__PURE__*/React.createElement(ButtonsContainer, null, renderFilterToolbar));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var nextState = updateFilters(nextProps, prevState)(prevState);
      return !isEqual(nextState, prevState) ? nextState : null;
    }
  }]);

  return FilterBarImpl;
}(PureComponent);
FilterBarImpl.propTypes = {
  filters: PropTypes.array,
  fixedFilters: PropTypes.array,
  onRemoveFilter: PropTypes.func,
  onRemoveAllFilters: PropTypes.func,
  renderToolbar: PropTypes.func,
  containerProps: PropTypes.object,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default FilterBarImpl;
//# sourceMappingURL=FilterBarImpl.js.map
